// extracted by mini-css-extract-plugin
module.exports = {"root":"_3HYsFUt0p23-c_ug69qKi-","content":"A8MI1zxjaSK0a9puklSJm","socialLink":"_3m-VpWUBw7MDjxGU4oBJ94","phone":"_4VemVtr5bJ_LsJ0a8M9IS"};